import { render, staticRenderFns } from "./InventoryDetail.vue?vue&type=template&id=0c44868a&"
import script from "./InventoryDetail.vue?vue&type=script&lang=js&"
export * from "./InventoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./InventoryDetail.vue?vue&type=style&index=0&id=0c44868a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports